import Vue from 'vue'
import App from './App.vue'

// import { MdButton, MdContent } from 'vue-material'
import VueRouter from 'vue-router';
import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import Index from './pages/Position.vue'


const routes = [
    {path: '/position/:id', component: Index},
];

const router = new VueRouter({
    mode: 'history',
    routes
});

Vue.use(VueMaterial);
Vue.use(VueRouter);

Vue.config.productionTip = false;

new Vue({
    router,
    render: h => h(App),
}).$mount('#app');
